import gql from "graphql-tag";

export const UNASSIGN_SHELF_COMPANY_FROM_ORDER = gql`
  mutation UnAssignShelfCompanyFromOrder($orderId: ID!) {
    unAssignShelfCompanyFromOrder(orderId: $orderId) {
      feedback
    }
  }
`;
